import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateTrainingStatus = ({ id, isActive }) => {
  const mutation = require("../api/mutation/updateTrainingStatus.gql");
  const variables = { id, isActive };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.updateTrainingStatus };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
